/* TextBlock — Editable text content block with inline editing */

import InlineTextEditor from '@/components/cms/InlineTextEditor'

interface TextBlockProps {
  data: Record<string, string>
  onUpdateData?: (updates: Record<string, string>) => void
}

export default function TextBlock({ data, onUpdateData }: TextBlockProps) {
  const heading = data.heading || 'Section Heading'
  const body = data.body || 'Write your content here. This block supports rich text formatting and can be used for any paragraph-length content.'

  return (
    <div data-testid="card-text-block" className="group rounded-xl bg-white/[0.02] border border-white/[0.04] hover:border-white/[0.08] transition-[border-color] duration-300 p-6">
      {onUpdateData ? (
        <InlineTextEditor
          value={heading}
          onChange={(v) => onUpdateData({ heading: v })}
          variant="heading"
          placeholder="Section Heading"
          className="text-lg font-semibold text-white/85 mb-3 tracking-tight leading-snug"
        />
      ) : (
        heading && (
          <h3 className="text-lg font-semibold text-white/85 mb-3 tracking-tight leading-snug">
            {heading}
          </h3>
        )
      )}

      {onUpdateData ? (
        <InlineTextEditor
          value={body}
          onChange={(v) => onUpdateData({ body: v })}
          variant="body"
          placeholder="Write your content here…"
          className="text-sm text-white/40 leading-relaxed group-hover:text-white/50 transition-colors"
        />
      ) : (
        <p className="text-sm text-white/40 leading-relaxed group-hover:text-white/50 transition-colors">
          {body}
        </p>
      )}
    </div>
  )
}
